import { Controller } from 'stimulus'

/**
 * Manages js for the remote checked functionality (StimulusJS controller)
 *
 * @class RemoteCheckedController
 * @memberof Controllers
 */
export default class extends Controller {
  static targets = [ 'checkable' ]

  /**
   * @function Controllers.RemoteCheckedController.trigger
   * @memberof Controllers
   * @description Mark all checkable targets true and dispatch custom event.
   *
   * @param {Event} event
   */
  trigger(event) {
    this.checkableTargets.forEach(checkable => {
      if (event.target.id === checkable.dataset.remoteCheckedId) {
        checkable.checked = true
        checkable.dispatchEvent(new CustomEvent('change'))
      }
    })
  }
}
